/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ErrorMessage } from '@hookform/error-message';
import { FormProvider, useForm } from 'react-hook-form';
import { DynamicFieldItemData } from './dynamic-control-types';
import { DynamicControl } from './DynamicControl';
import * as S from './formGenerator.styled';
import './form-styles.css';
import styled from '@emotion/styled';
import api from 'api';
import { useEffect } from 'react';

interface FormProps {
    fields: DynamicFieldItemData[];
    isLastPage: boolean;
    currentPage: number;
    docId: number;
    defaultValues: Record<string, any>;
    resetFieldsOnPageChange?: boolean;
    next: () => void;
    prev: () => void;
    handleClose: (open: boolean) => void;
}

export const Form = ({
    docId,
    fields,
    isLastPage,
    currentPage,
    defaultValues,
    resetFieldsOnPageChange,
    prev,
    next,
    handleClose,
}: FormProps) => {
    const formMethods = useForm({
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting, errors },
        reset,
    } = formMethods;

    useEffect(() => {
        if (resetFieldsOnPageChange) {
            reset(defaultValues);
        }
    }, [fields, defaultValues, reset, resetFieldsOnPageChange]);

    const onSubmit = async (data: any, error: any) => {
        try {
            const resp = await api.governmentForms.post(docId, data);
            if (resp?.status === 200 || resp?.status === 201) {
                if (isLastPage) {
                    next();
                    handleClose(false);
                } else {
                    next();
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const RedErrorMessageContainer = styled.div`
        color: red;
    `;

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
            <S.GridContainer>
                <FormProvider {...formMethods}>
                    {fields?.map((d, i) => (
                        <S.GridItem>
                            <div key={i}>
                                <label htmlFor={d.fieldName}>
                                    <b>{d.label}</b>
                                </label>
                                <DynamicControl {...d} defaultValue={defaultValues[d.fieldName]} />
                                <RedErrorMessageContainer>
                                    <ErrorMessage errors={errors} name={d.fieldName} />
                                </RedErrorMessageContainer>
                            </div>
                        </S.GridItem>
                    ))}
                </FormProvider>
            </S.GridContainer>
            <S.Row style={{ marginTop: '10px' }}>
                <div className="actions-group" style={{ width: '100%' }}>
                    <S.BackButton id="left" onClick={prev} disabled={currentPage === 0}>
                        Back
                    </S.BackButton>
                    <S.NextButton id="right" onClick={handleSubmit(onSubmit)}>
                        {isSubmitting ? '...Saving' : isLastPage ? 'Submit' : 'Next'}
                    </S.NextButton>
                </div>
            </S.Row>
        </form>
    );
};
